import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteSalesTax } from '../../../../actions';

const SalesTaxDeleteButton = ({
  dispatchDeleteSalesTax,
  salesTaxId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteSalesTax({ salesTaxId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

SalesTaxDeleteButton.propTypes = {
  dispatchDeleteSalesTax: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  salesTaxId: PropTypes.number.isRequired,
};

SalesTaxDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteSalesTax: deleteSalesTax,
};

export default connect(null, mapDispatchToProps)(SalesTaxDeleteButton);
